export default __webpack_public_path__ + "images/sport_equipment.d494573.svg";